import React from "react";
import "./title.styles.css";

const Title = ({ children }: any) => {
  return <p className="title-text">{children}</p>;
};

export default Title;
